// extracted by mini-css-extract-plugin
export default {"dropdownTargetContainer":"OeNGmVus","dropdownPoint":"mTNIa2li","dropdownPanel":"S4IazJrB","right":"zr621_Rq","left":"HBJiE_V6","bottom":"VdoWONtR","top":"R7M02I9M"};